import React from 'react';

import { PrioridadeSolicitacao } from 'model/solicitacao/PrioridadeSolicitacao';
import { PrioridadesSelectOptions } from "./PrioridadesSelectOptions";


interface PrioridadeTagProps {
  prioridade: PrioridadeSolicitacao
  exibirIcone?: boolean
}

export const PrioridadeTag: React.FC<PrioridadeTagProps> = ({exibirIcone, prioridade}) => {
  const icone = exibirIcone ? PrioridadesSelectOptions.byId(prioridade.id).icone : <></>;
  return <>{icone} {prioridade.nome}</>
}
